import { appApi } from "@web/app/store/api";

// Tipado basado en la Sección 2 y 5 de tu Guía
export interface FeatureNode {
  id: string;
  name: string;
  feature_type: "MODULE" | "RESOURCE" | "ACTION";
  display_mode?: "MENU";
  feature_order: number;
  href: string;
  icon?: string;
  enabled: boolean;
  child_feature_list: FeatureNode[];
  actions?: Record<string, any>;
}

export interface PermissionsResponse {
  message: string;
  data: FeatureNode[];
}

export const accessApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    // Endpoint para el árbol del usuario actual (Sección 1)
    getPermissionsMe: builder.query<PermissionsResponse, void>({
      query: () => '/api/v1/permissions/me/features-tree',
      providesTags: ['Permissions'],
    }),

    // Endpoint por rol (Sección 8)
    getPermissionsByRole: builder.query<PermissionsResponse, string>({
      query: (role) => `/api/v1/permissions/role/${role}/features-tree`,
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetPermissionsMeQuery,
  useGetPermissionsByRoleQuery,
} = accessApi;